<template>
  <section class="tableactive-timebylapses">
    <div class="tableactive-timebylapses__title">Tiempo activo por lapsos de 15 minutos</div>
    <div class="tableactive-timebylapses__tables">
      <div class="tableactive-timebylapses__tables__firts">
        <div class="tableactive-timebylapses__tables__firts__col-first">1T</div>
        <template v-for="(val, index) in infoTimePerLapse['1T']">
          <template v-if="val.name != 'TOTAL'">
            <div :key="index" class="tableactive-timebylapses__tables__firts__col">
              <div class="tableactive-timebylapses__tables__firts__col__row-title">{{ val.name }}</div>
              <div class="tableactive-timebylapses__tables__firts__col__row-value">{{ val.minutes }}</div>
            </div>
          </template>
          <template v-else>
            <div :key="index" class="tableactive-timebylapses__tables__firts__col">
              <div class="tableactive-timebylapses__tables__firts__col__row-title-total">{{ val.name }}</div>
              <div class="tableactive-timebylapses__tables__firts__col__row-value-total">{{ val.minutes }}</div>
            </div>
          </template>
        </template>
      </div>
      <div class="tableactive-timebylapses__tables__second">
        <div class="tableactive-timebylapses__tables__second__col-first">2T</div>
        <template v-for="(val, index) in infoTimePerLapse['2T']">
          <template v-if="val.name != 'TOTAL'">
            <div :key="index" class="tableactive-timebylapses__tables__second__col">
              <div class="tableactive-timebylapses__tables__second__col__row-title">{{ val.name }}</div>
              <div class="tableactive-timebylapses__tables__second__col__row-value">{{ val.minutes }}</div>
            </div>
          </template>
          <template v-else>
            <div :key="index" class="tableactive-timebylapses__tables__second__col">
              <div class="tableactive-timebylapses__tables__second__col__row-title-total">{{ val.name }}</div>
              <div class="tableactive-timebylapses__tables__second__col__row-value-total">{{ val.minutes }}</div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TableActiveTimeByLapses',
  components: {},

  props: {
    infoTimePerLapse: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.tableactive-timebylapses {
  width: 100%;
  height: auto;

  &__title {
    width: 100%;
    height: 14px;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 14px;
    letter-spacing: normal;
    text-align: center;
    color: #132839;
    font-family: 'Avenir-Demi';
    @media screen and (max-width: 340px) {
      font-size: 11px;
    }
  }
  &__tables {
    margin-top: 10px;
    display: inline-flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    width: 100%;
    height: 52px;
    @media screen and (max-width: 740px) {
      height: auto;
    }
    &__firts {
      width: 49.2%;
      height: 52px;
      // background: rgb(103, 104, 102);
      border-radius: 6px;
      border: solid 1px #b4c9dd;
      overflow: hidden;
      display: inline-flex;
      justify-content: left;
      align-content: center;
      align-items: center;
      @media screen and (max-width: 740px) {
        display: inline-block;
        height: auto;
      }
      &__col-first {
        width: 6.97%;
        height: 52px;
        border-right: 1px solid white;
        font-size: 11px;
        font-weight: normal;
        font-stretch: normal;
        background-color: #52a0fc;
        font-style: normal;
        line-height: 52px;
        letter-spacing: normal;
        text-align: center;
        color: #fff;
        font-family: 'Avenir-Demi';
        @media screen and (max-width: 740px) {
          width: 100%;
          border-bottom: 1px solid white;
          height: 34px;
          line-height: 34px;
          border-right: 0px solid white;
        }
      }
      &__col {
        width: 18.6%;
        height: 52px;
        border-right: 1px solid white;
        background: mediumturquoise;
        @media screen and (max-width: 740px) {
          width: 100%;
          border-bottom: 2px solid white;
          height: 26px;
          line-height: 26px;
          display: inline-flex;
          border-right: 0px solid white;
          justify-content: left;
          align-content: center;
          align-items: center;
        }
        &__row-title {
          width: 100%;
          height: 26px;
          background-color: #52a0fc;
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-family: 'Avenir-Demi';
          font-style: normal;
          line-height: 26px;
          letter-spacing: normal;
          text-align: center;
          color: #fff;
          @media screen and (max-width: 740px) {
            width: 50%;
          }
        }
        &__row-value {
          width: 100%;
          height: 26px;
          background-color: #ffffff;
          font-family: 'Avenir-Demi';
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 26px;
          letter-spacing: normal;
          text-align: center;
          color: #132839;
          @media screen and (max-width: 740px) {
            width: 50%;
          }
        }
        &__row-title-total {
          width: 100%;
          height: 26px;
          background-color: #132739;
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-family: 'Avenir-Bold';
          font-style: normal;
          line-height: 26px;
          letter-spacing: normal;
          text-align: center;
          color: #fff;
          @media screen and (max-width: 740px) {
            width: 50%;
          }
        }
        &__row-value-total {
          width: 100%;
          height: 26px;
          background-color: #ffffff;
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-family: 'Avenir-Bold';
          font-style: normal;
          line-height: 26px;
          letter-spacing: normal;
          text-align: center;
          color: #132839;
          @media screen and (max-width: 740px) {
            width: 50%;
          }
        }
      }
      &__col:last-child {
        border: none;
      }
    }
    &__second {
      width: 49.2%;
      height: 52px;
      // background: rgb(103, 104, 102);
      border-radius: 6px;
      border: solid 1px #b4c9dd;
      overflow: hidden;
      display: inline-flex;
      justify-content: left;
      align-content: center;
      align-items: center;
      @media screen and (max-width: 740px) {
        display: inline-block;
        height: auto;
      }
      &__col-first {
        width: 6.97%;
        height: 52px;
        border-right: 1px solid white;
        font-size: 11px;
        font-weight: normal;
        font-stretch: normal;
        background-color: #52a0fc;
        font-style: normal;
        line-height: 52px;
        letter-spacing: normal;
        text-align: center;
        color: #fff;
        font-family: 'Avenir-Demi';
        @media screen and (max-width: 740px) {
          width: 100%;
          border-bottom: 1px solid white;
          height: 34px;
          line-height: 34px;
          border-right: 0px solid white;
        }
      }
      &__col {
        width: 18.6%;
        height: 52px;
        border-right: 1px solid white;
        background: mediumturquoise;
        @media screen and (max-width: 740px) {
          width: 100%;
          border-bottom: 2px solid white;
          height: 26px;
          line-height: 26px;
          display: inline-flex;
          border-right: 0px solid white;
          justify-content: left;
          align-content: center;
          align-items: center;
        }
        &__row-title {
          width: 100%;
          height: 26px;
          background-color: #52a0fc;
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-family: 'Avenir-Demi';
          font-style: normal;
          line-height: 26px;
          letter-spacing: normal;
          text-align: center;
          color: #fff;
          @media screen and (max-width: 740px) {
            width: 50%;
          }
        }
        &__row-value {
          width: 100%;
          height: 26px;
          background-color: #ffffff;
          font-family: 'Avenir-Demi';
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 26px;
          letter-spacing: normal;
          text-align: center;
          color: #132839;
          @media screen and (max-width: 740px) {
            width: 50%;
          }
        }
        &__row-title-total {
          width: 100%;
          height: 26px;
          background-color: #132739;
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-family: 'Avenir-Bold';
          font-style: normal;
          line-height: 26px;
          letter-spacing: normal;
          text-align: center;
          color: #fff;
          @media screen and (max-width: 740px) {
            width: 50%;
          }
        }
        &__row-value-total {
          width: 100%;
          height: 26px;
          background-color: #ffffff;
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-family: 'Avenir-Bold';
          font-style: normal;
          line-height: 26px;
          letter-spacing: normal;
          text-align: center;
          color: #132839;
          @media screen and (max-width: 740px) {
            width: 50%;
          }
        }
      }
      &__col:last-child {
        border: none;
      }
    }
  }
}
</style>
